import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'

export default props => {
    useStyles(classes)
    return <div className={classes.Container}>
        <div className={classes.Hd}>
            <span className={classes.Title}>{props.title}</span>
            {props.extra}
        </div>
        {
            props.children && <div className={`${classes.Bd} ${!props.noPadding ? classes.Padding: ''} ${props.bottomLine ? classes.BottomLine: ''}`}>
                {props.children}
            </div>
        }
    </div>
}